import { cn } from '#app/utils/misc'
import { Icon } from './ui/icon'

export default function Loader({ className }: { className?: string }) {
	return (
		<div
			className={cn(
				'absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-50',
				className,
			)}
		>
			<Icon name="loader-2" className="animate-spin" size="md" />
		</div>
	)
}
